export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/admin": [4,[2]],
		"/admin/ajustes": [5,[2]],
		"/admin/audit": [6,[2]],
		"/admin/cola-impresion": [7,[2]],
		"/admin/desglose": [8,[2]],
		"/admin/devices": [9,[2]],
		"/admin/empleados": [10,[2]],
		"/admin/etiquetas": [11,[2]],
		"/admin/generar-orden": [12,[2]],
		"/admin/impresoras": [13,[2]],
		"/admin/lineas": [14,[2]],
		"/admin/mantenimiento": [15,[2]],
		"/admin/ordenes": [16,[2]],
		"/admin/planificador": [17,[2]],
		"/admin/produccion": [18,[2]],
		"/admin/producibles": [19,[2]],
		"/admin/recovery": [20,[2]],
		"/admin/scrap": [21,[2]],
		"/admin/tablero-ot": [22,[2]],
		"/admin/trazabilidad": [23,[2]],
		"/admin/usuarios": [24,[2]],
		"/calidad": [25],
		"/calidad/insumos": [26],
		"/calidad/ordenes": [27],
		"/calidad/runs": [28],
		"/calidad/runs/[runId]": [29],
		"/login": [30],
		"/logistica": [31],
		"/logistica/despachos": [32],
		"/logistica/despachos/[id]": [33],
		"/logistica/devoluciones": [34],
		"/logistica/devoluciones/[id]": [35],
		"/logistica/entregas": [36],
		"/logistica/entregas/[picking_id]": [37],
		"/logistica/recepcion-mp": [39],
		"/logistica/recepcion-mp/[id]": [40],
		"/logistica/recepcion": [38],
		"/logistica/reposicion": [41],
		"/logistica/transferencias": [42],
		"/produccion": [43],
		"/produccion/checklist": [44],
		"/produccion/mi-produccion": [45],
		"/produccion/mi-turno": [46],
		"/produccion/shift": [47],
		"/produccion/shift/close": [48],
		"/profile": [49],
		"/profile/change-password": [50],
		"/profile/change-pin": [51],
		"/profile/totp": [52],
		"/q/envio/[token]": [53],
		"/tablero": [54],
		"/tablero/antiguedad": [55]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';